import type { DataStore } from "./Store"
import { ShipApi } from "../Types/Generated/LogbookApi/ShipApi"
import type { IShipImportResponse, IShipResponse } from "../Types"
import type { IShipCreateRequest } from "../Types/Generated/LogbookServer/ShipApi"

export function importShipWithStore(
  store: DataStore,
  shipId: number,
  attachment: File,
): Promise<IShipImportResponse> {
  return store.mutate({
    request: (client) =>
      new ShipApi(client).ships.import({ params: { shipId }, body: { attachment } }).call(),
  });
}

export function createShipWithStore(store: DataStore, values: IShipCreateRequest): Promise<IShipResponse> {
  return store.mutate({
    request: (client) =>
      new ShipApi(client).ships.create({ params: {}, body: values }).call(),
    reconcile: (response) => ({
      entities: {
        Ship: [response.ship],
        Settings: response.settings ?? [],
        ShipUser: [
          ...(response.users ?? []),
          ...(response.user ? [response.user] : []),
        ],
      },
    }),
  });
}
